import { render } from "./Fillin.vue?vue&type=template&id=cffd736c&scoped=true"
import script from "./Fillin.vue?vue&type=script&lang=js"
export * from "./Fillin.vue?vue&type=script&lang=js"

import "./Fillin.vue?vue&type=style&index=0&id=cffd736c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffd736c"]])

export default __exports__